import type { IRawData } from "app/pages/website-analysis/demographicsUserBased/utils/fetchData";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { DEFAULT_WEBSITES_DELIMITER } from "app/services/sitesService/consts";

export const sortRawDataAsSelectedSites = (rawData: IRawData): IRawData => {
    const rawDataSites = Object.keys(rawData);
    const params = proNavigator.getParams();
    const { key } = params;
    const selectedSites = key.split(DEFAULT_WEBSITES_DELIMITER);
    const sortedRawDataSites = rawDataSites.sort((site, otherSite) => {
        return selectedSites.indexOf(site) > selectedSites.indexOf(otherSite) ? 1 : -1;
    });
    const sortRawData = sortedRawDataSites.reduce((sortRawData, site) => {
        return { ...sortRawData, [site]: rawData[site] };
    }, {});
    return sortRawData;
};
